<form [formGroup]="setupForm">
  <h1 class="page__title my-5 h2">{{ 'mail_send_configuration' | translate }}</h1>

  <div class="">
    <ng-container>
      <div class="form-group row">
        <label class="d-flex col-sm-2" translate
          >mail_send_title_input
          <div
            class="tooltip-custom border rounded-circle border-1"
            #tooltip="matTooltip"
            matTooltipPosition="above"
            matTooltipClass="tooltip-class"
            matTooltip="{{ 'mail_send_title_optional' | translate }}"
          >
            <p>?</p>
          </div>
        </label>
        <div class="col-8">
          <ng-container>
            <input type="text" class="form-control" formControlName="name" wsbAppControlValidator [fc]="setupForm.get('name')" />
            <wsb-validation-error-msg [fc]="setupForm.get('name')"></wsb-validation-error-msg>
            <small>{{ 'mail_send_title_input_help' | translate }}</small>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container>
      <div class="form-group row">
        <label class="d-flex col-sm-2" translate
          >mail_subject
          <div
            class="tooltip-custom border rounded-circle border-1"
            #tooltip="matTooltip"
            matTooltipPosition="above"
            matTooltipClass="tooltip-class"
            matTooltip="{{ 'mail_send_subject_input_help' | translate }}"
          >
            <p>?</p>
          </div>
        </label>
        <div class="col-8 d-flex">
          <ng-container>
            <div class="me-3 w-100">
              <input
                type="text"
                class="form-control"
                formControlName="subject"
                [placeholder]="'mail_send_subject_ph' | translate"
                wsbAppControlValidator
                [fc]="setupForm.get('subject')"
              />
              <wsb-validation-error-msg [fc]="setupForm.get('subject')"></wsb-validation-error-msg>
            </div>
            <div class="col-4 pe-0">
              <div class="d-flex">
                <ng-select
                  #dynamicsFieldsSelection
                  formControlName="dynamicField"
                  [items]="dynamicsFields"
                  bindLabel="value"
                  bindValue="idField"
                  [clearable]="false"
                  class="form-control"
                  (change)="selectionChange($event)"
                  [placeholder]="'mail_send_dynamic_fields' | translate"
                >
                  <ng-template ng-label-tmp let-item="item">
                    <span>{{ item.label | translate }}</span>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.label | translate }}</span>
                  </ng-template>
                </ng-select>
                <div
                  class="tooltip-custom border rounded-circle border-1"
                  #tooltip="matTooltip"
                  matTooltipPosition="above"
                  matTooltipClass="tooltip-class"
                  matTooltip="{{ 'mail_send_dynamic_fields_help' | translate }}"
                >
                  <p class="w-14">?</p>
                </div>
              </div>
              <wsb-validation-error-msg [fc]="setupForm.get('dynamicField')"></wsb-validation-error-msg>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container>
      <div class="form-group row">
        <label class="d-flex col-sm-2" translate
          >mail_send_campaign_input
          <div
            class="tooltip-custom border rounded-circle border-1"
            #tooltip="matTooltip"
            matTooltipPosition="above"
            matTooltipClass="tooltip-class"
            matTooltip="{{ 'mail_send_campaign_input_help' | translate }}"
          >
            <p>?</p>
          </div>
        </label>
        <div class="col-8">
          <ng-container>
            <ng-select
              bindValue="id"
              [items]="emailCampaignList"
              [formControl]="list"
              bindLabel="title"
              bindValue="idCampaign"
              [clearable]="false"
              class="form-control col-4"
            >
            </ng-select>
            <wsb-validation-error-msg [fc]="list"></wsb-validation-error-msg>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container>
      <div class="form-group row">
        <label class="d-flex col-sm-2" translate
          >mail_send_analytics_input
          <div
            class="tooltip-custom border rounded-circle border-1"
            #tooltip="matTooltip"
            matTooltipPosition="above"
            matTooltipClass="tooltip-class"
            matTooltip="{{ 'mail_send_analytics_input_help' | translate }}"
          >
            <p>?</p>
          </div>
        </label>
        <div class="col-8">
          <ng-container>
            <input
              type="text"
              class="form-control"
              formControlName="webAnalitics"
              [placeholder]="'mail_send_analytics_ph' | translate"
              wsbAppControlValidator
              [fc]="setupForm.get('webAnalitics')"
            />
            <wsb-validation-error-msg [fc]="setupForm.get('webAnalitics')"></wsb-validation-error-msg>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</form>
